import { Observable } from "rxjs";
import { POSTable_Item_Extra } from "../../services/IInHouseOrderService";

export interface ITableOverviewService {
  /** menucourse */
  readonly menucourses$: Observable<IMenuCourse[]>;
  /** tableSeatItems */
  readonly tableSeats$: Observable<ReadonlyArray<ITableSeat>>;
  /** user phone number */
  readonly phoneNumber$: Observable<string>;

  /** ändert die Notification auf SMS mit engegebener Nummer */
  ChangePhoneNumber(number: string): Promise<boolean>;
  /** ??? */
  sumItems(items: ReadonlyArray<ITableSeatItem>): ITableSeatItem[];
}

/** Benachrichtigungsart */
export enum ITableSeat_NotificationTyp {
  /** Keine Benachrichtigung */
  NONE = 0,
  /** Per WebPush */
  WebPush = 1,
  /** Per SMS */
  SMS = 2,
  /** Per FCM (Firebase Cloud Messaging) */
  FCM = 3,
}

export interface ITableSeat {
  /** id einzigartig: wird von der Oberfläche zum tracken von Elementen genutzt
   * (ist die Seatnummer, wo alle ohne usertoken zur 0 werden)
   */
  readonly id: number | string;
  /** Nickname (kann vom echten namen abweichen und wird zur Anzeige genutzt, z.B. auch am POS/mPOS) */
  readonly nickname: string;
  /** ??? */
  readonly isGuest: boolean;
  /** Wenn NULL => Ohne Zuordnung (0 > NULL) */
  readonly seat: number | null;
  /** art der notification */
  readonly notificationTyp: ITableSeat_NotificationTyp;
  /** table seat items */
  readonly items: ReadonlyArray<ITableSeatItem>;
  /** gesamt betrag aller offenen Items */
  readonly open_price: number;
  /** Unbezahlte Artikel pro Platz */
  readonly open_amount: number;
}

export interface ITableSeatItem {
  /** id einzigartig: wird von der Oberfläche zum tracken von Elementen genutzt */
  readonly id: number;
  /** Name des Items, müsste bei Language change upgedated werden. */
  readonly label: string;
  /** verfügbare anzahl */
  readonly count: number;
  /** Einzelpreis,*/
  readonly price: number;
  readonly valid_date?: number;
  readonly extras: ReadonlyArray<ITablSeatItemExtra>;
  readonly hasComment?: boolean;
  readonly comment?: string;
  readonly state: OrderedItemState;
}

export interface ITablSeatItemExtra {
  /** extra name */
  readonly title: string
  /** extra subIndex (positiv und negativ erzeugen die Verkettung) */
  readonly subIndex: number;
  /** extra count */
  readonly count: number;
}

export enum OrderedItemState {
  None = 0,
  InPreperation = 1,
  ReadyForPickUp = 2,
  PickedUp = 3
}

export interface IMenuCourse {
  readonly name: string;
  readonly id: number;
}